<template>
  <a class="media d-flex justify-content-center align-items-center" :href="`${ api_url }/${ item.url }`" target="_black">
    <div class="text-center">
    <i class="fa fa-download fa-3x"></i>
    <br />
    Midia para download, clique para iniciar!
    </div>
  </a>
</template>

<script>

export default {
  props: {
    item: {
      required: true
    }
  },
  data () {
    return {
      api_url: process.env.VUE_APP_ROOT_BASE,
    }
  },
  methods: {
    downloadFile: function () {
      this.item.url
    }
  }
}
</script>

<style scoped>
  .media {
    height: 100%;
    border: black dotted 2px;
    user-select: none;
    cursor: pointer;
  }
</style>
